// extracted by css-extract-rspack-plugin
export default {"titleSubtext":"titleSubtext-dhJbHZ","userInfoItem":"userInfoItem-xOi6RR","userInfoItemName":"userInfoItemName-eZo4zE"};